/**
 * TtfLocaTable.ts class for EJ2-PDF
 */
var TtfGlyphHeader = /** @class */ (function () {
    function TtfGlyphHeader() {
    }
    return TtfGlyphHeader;
}());
export { TtfGlyphHeader };
